import store from '../'

let resource = store.defineResource({
  name: "channels",
  endpoint: "library/units"
})

export default resource



// WEBPACK FOOTER //
// ./src/store/models/channels.js